
(function($){

    var settings = {};

    var methods = {
        init : function(options) {

            // Создаём настройки по-умолчанию, расширяя их с помощью параметров, которые были переданы
            settings = $.extend({
                animationTime: 200,
                afterOpen: function(){},
                afterClose: function(){},
                'select': function(){}
            }, options);

            return this.each(function(){

                var $this = $(this);

                var id = $this.data('dropdown-id');

                var data = $this.data('dropdown');
                var $trigger = $this.siblings('*[data-dropdown-id=' + id + ']');

                // Если плагин ещё не проинициализирован
                if (!data) {
                    /*
                     * Тут выполняем инициализацию (конструктор плагина)
                     */

                    data = {
                        'dropdown': $this,
                        'trigger': $trigger
                    };

                    $('body').on("click.dropdown", function(e) {
                        var clicked = $(e.target);

                        if ((!(clicked.is($this) || clicked.parents().is($this)))) {
                            methods.close.apply($this);
                        }
                    });

                    $trigger.on('click.dropdown', function(e){

                        if ($this.is(':visible')) {
                            methods.close.apply($this);
                        } else {
                            methods.open.apply($this);
                        }

                        return false;
                    });

                    $this.on('click.dropdown', '.dropdown-in span', function(e){
                        methods.close.apply($this);
                        return false;
                    });

                    $this.on('click.dropdown', '.dropdown-in a', function(e){
                        var $a = $(this);
                        $trigger.html($a.html()+'<svg><use xlink:href="#ic_chevron"></use></svg>');
                        $this.find('.dropdown-in span').hide();
                        $this.find('.dropdown-in a').show();
                        $a.hide();
                        $a.siblings('span').show();

                        methods.close.apply($this);

                        settings.select($a);

                        $this.trigger('change-season-playoff', {id: $a.prop('id')});

                        return false;
                    });

                    $this.data('dropdown', data);

                    $this.on('season-changed', function(e, seasonId) {
                        var $a = $this.find('li[data-season-id=' + seasonId + '] a');
                        $trigger.html($a.html() + '<svg><use xlink:href="#ic_chevron"></use></svg>');
                        $this.find('.dropdown-in span').hide();
                        $this.find('.dropdown-in a').show();
                        $a.hide();
                        $a.siblings('span').show();
                    });
                }
            });
        },

        /** деструктор плагина */
        destroy: function() {
            return this.each(function(){

                var $this = $(this);

                // unbind events
                $(window).unbind('.dropdown');
                // remove data
                $this.removeData('dropdown');
            });
        },

        open: function() {

            var $this = this;

            $this.fadeIn(settings.animationTime, function(){
                if (typeof PerfectScrollbar !== 'undefined') {
                    if (typeof $this.data('ps') === 'undefined') {
                        $this.data('ps', new PerfectScrollbar($this.find('.dropdown-in').get(0), {
                            suppressScrollX: true
                        }));
                    } else {
                        $this.data('ps').update();
                    }

                }
                settings.afterOpen();
                $('.js-filter-season').addClass('opened');
            });

        },

        close: function() {

            this.fadeOut(settings.animationTime, function(){
                settings.afterClose();
                $('.js-filter-season').removeClass('opened');
            });
        }
    };

    $.fn.dropdown = function(method) {

        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));

        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);

        } else {
            $.error('Метод с именем ' +  method + ' не существует для jQuery.dropdown');
        }

        return null;
    };

})(jQuery);
